/*import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// Modules
import auth from './auth.store.js'

export const store = new Vuex.Store({
  modules: {
    auth: auth
  }
})
*/

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// TYPES
const MAIN_SET_COUNTER = 'MAIN_SET_COUNTER'
const LOGIN = 'LOGIN'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGOUT = 'LOGOUT'

const TOKEN_NAME = 'token'

// STATE
const state = {
  counter: 0,
  isLoggedIn: localStorage.getItem(TOKEN_NAME) !== null,
  pending: false
}

// MUTATIONS
const mutations = {
  [MAIN_SET_COUNTER](state, obj) {
    state.counter = obj.counter
  },
  [LOGIN](state) {
    state.pending = true
  },
  [LOGIN_SUCCESS](state) {
    state.isLoggedIn = true
    state.pending = false
  },
  [LOGOUT](state) {
    state.isLoggedIn = false
    state.pending = false
  }
}

// ACTIONS
const actions = ({
  setCounter({ commit }, obj) {
    commit(MAIN_SET_COUNTER, obj)
  },
  login({
    state,
    commit,
    rootState
  }, token) {
    commit(LOGIN) // show spinner
    localStorage.setItem(TOKEN_NAME, token)
    commit(LOGIN_SUCCESS)
  },

  logout({
    commit
  }) {
    localStorage.removeItem(TOKEN_NAME)
    commit(LOGOUT)
  }
})

export default new Vuex.Store({
  state,
  mutations,
  actions
});



// WEBPACK FOOTER //
// ./WebApp/store/index.js